import Api from '@/api/api.js'

export default {

    //Enregistrer une societé
    importEmploye(id , data) {
        const promise = Api().post('/societe/import-employes/'+id, data)
        return promise.then((response) => response.data)
    },

    listeEmployes(id){
        const promise = Api().get('/societe/'+id+'/employes')
        return promise.then((response) => response.data)
    }


}